/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na organizátory zobrazování obsahu.
 */
class ViewerDirectorFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<ViewerDirector>} ViewerDirector Konstruktor pro organizátory.
   * @param {QueueFactory} queueFactory Továrna na fronty asynchronních akcí.
   * @param {ViewerThreadFactory} threadFactory Továrna na vlákna zobrazující obsah.
   */
  constructor(ViewerDirector, queueFactory, threadFactory) {
    this.ViewerDirector = ViewerDirector;
    this.queueFactory = queueFactory;
    this.threadFactory = threadFactory;
  }

  /**
   * Vytvoří nový organizátor zobrazování obsahu.
   * @param {HTMLElement} el ELement, do kterého se prolínač vykresluje.
   * @returns {ViewerDirector} Vytvořený organizátor.
   */
  create(el) {
    return new this.ViewerDirector(el, this.queueFactory, this.threadFactory);
  }
}

export default ViewerDirectorFactory;
